import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { map, tap } from 'rxjs/operators';
import { AdvancedFiltersFormCustomerReasonStore } from './advanced-filters-form-customer-reason.store';
import { FiltersFormStore } from '../filter-forms/filter-forms.store';

@Component({
  selector: 'app-advanced-filters-form-customer-reason',
  templateUrl: './advanced-filters-form-customer-reason.component.html',
  styleUrls: ['./advanced-filters-form-customer-reason.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    AdvancedFiltersFormCustomerReasonStore
  ]
})
export class AdvancedFiltersFormCustomerReasonComponent implements OnInit, OnDestroy, ControlValueAccessor {

  value$ = this.store.value$

  selectedItems$ = this.filtersFormStore.customerReason$.pipe(
    tap((entities) => {
        this.saveValue(entities)
    }),
    map((entities) => entities.length ? entities : '')
  )

  onChange: any = () => {}
  onTouch: any = () => {}

  constructor(
    public ngControl: NgControl,
    private filtersFormStore: FiltersFormStore,
    private store: AdvancedFiltersFormCustomerReasonStore
  ) {
    ngControl.valueAccessor = this;
  }

  ngOnInit(): void {}

  writeValue(value: string){ }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }

  onValueChange(event: string[]){
    this.saveValue(event)
  }

  saveValue(value){
    this.onChange(value)
    if(this.ngControl.untouched){
      this.onTouch()
    }
  }

  ngOnDestroy(){
    this.saveValue('')
  }
}
